import selectColorFacebook from "@/components/common/selectColorFacebook";

export const FacebookInitialData = {
  payload: {
    name: "",
    hide_the_numbers: "0",
    url: "",
    company: "",
    title: "",
    web_site: "",
    image: "",
    image_name: "",
    image_type: "",
    image_path: "",
    welcome_screen: "",
    welcome_path: "",
    design_colors_primary: selectColorFacebook[0].color,
    design_colors_button: selectColorFacebook[0].buttonColor,
  },
};
